import { useState } from 'react';

/**
 * The error and busy state around one form's requests. `submit` clears the last error, marks the form busy,
 * and resolves to undefined when the request failed, having set the message `failureMessage` gives.
 */
export function useSubmission() {
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit<T>(request: () => Promise<T>, failureMessage: (err: unknown) => string): Promise<T | undefined> {
    setError(null);
    setSubmitting(true);
    try {
      return await request();
    } catch (err) {
      setError(failureMessage(err));
      return undefined;
    } finally {
      setSubmitting(false);
    }
  }

  return { error, submitting, submit, clearError: () => setError(null) };
}
